import {createSelector} from 'reselect';

import {getUIState} from '../ui-selectors';

const getConnectedFormsState = createSelector([getUIState], (uiState) => uiState.connectedForms);

export const getActiveFieldId = createSelector(
    [getConnectedFormsState],
    (reportState) => reportState.activeFieldId
);

const getConnectedFormsReportState = createSelector(
    [getConnectedFormsState],
    (reportState) => reportState.connectedFormsReport
);

const getConnectedFormsChartState = createSelector(
    [getConnectedFormsReportState],
    (connectedFormsReport) => connectedFormsReport.timeseriesChart
);

export const getCurrentReportChartIsLoading = createSelector(
    [getConnectedFormsChartState],
    (timeseriesChartState) => timeseriesChartState.isLoading
);

export const isChartTimedOut = createSelector(
    [getConnectedFormsChartState],
    (timeseriesChartState) => timeseriesChartState.isTimedOut
);

export const isChartErrored = createSelector(
    [getConnectedFormsChartState],
    (timeseriesChartState) => timeseriesChartState.isErrored
);

export const getCurrentReportChartData = createSelector(
    [getConnectedFormsChartState],
    (timeseriesChartState) => timeseriesChartState.chartData
);

export const getConnectedFormSchema = createSelector(
    [getConnectedFormsState],
    (formState) => formState.connectedFormSchema
);
